<template>
    <v-bottom-sheet inset v-model="show" max-width="400">
        <v-card tile>
            <v-card-text class="pa-4">
                <img src="/images/front/icon.png" width="80" style="float:left" class="mr-4">
                {{ $t('notifications.notifications_info') }}
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="close">{{ $t('notifications.no_thanks') }}</v-btn>
                <v-btn color="primary" @click="enable">{{ $t('notifications.enable') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
import PushNotifications from '../../core/pushnotifications'

export default {
    data () {
        return {
            show: false,
            notifications: new PushNotifications(EasyEvent.publicVapidKey)
        }
    },

    created () {
        if ('Notification' in window && 'serviceWorker' in navigator && Notification.permission == 'default') {
            let denied = JSON.parse(localStorage.getItem('notification-denied'))
            if (denied == null) {
                this.show = true
            } else {
                let now = new Date().getTime()
                if (denied.date < (now - 31*24*60*60*1000)) { // older than month
                    localStorage.removeItem('notification-denied')
                    this.show = true
                }
            }
        }
    },

    methods: {
        enable () {
            this.notifications.findActiveSubscription()
            this.show = false
        },

        close () {
            this.show = false
            localStorage.setItem('notification-denied', JSON.stringify({
                denied: true,
                date: new Date().getTime()
            }))
        }
    }
}
</script>
